import React from 'react';

// Canonical page-level container: every top-level route page should wrap its
// content in this so left/right margins and max width line up when
// navigating between pages instead of jumping around.
//
// Width is the shared `--frame-dashboard` token (see src/styles/theme.css).
// No side padding on top of that — cards and toolbar content run flush to
// this container's edges, matching the Dashboard's original layout.
export function PageContainer({ children, style }) {
  return (
    <div style={{ maxWidth: 'var(--frame-dashboard)', margin: '0 auto', padding: '32px 0', ...style }}>
      {children}
    </div>
  );
}

// Canonical page title. One per page — use a lower heading level for any
// other headings on the page.
export function PageTitle({ children, style }) {
  return (
    <h1
      style={{
        margin: 0,
        fontSize: 'var(--text-page-size)',
        fontWeight: 'var(--text-page-weight)',
        letterSpacing: 'var(--text-page-tracking)',
        color: 'var(--text-primary)',
        ...style,
      }}
    >
      {children}
    </h1>
  );
}

// Convenience wrapper for the common "title + subtitle (+ actions)" header
// shape. Pages with a bespoke header body (e.g. a line of custom content
// below the title) can use PageTitle directly instead.
export default function PageHeader({ title, subtitle, actions, style, ...rest }) {
  return (
    <header
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 16,
        marginBottom: 20,
        flexWrap: 'wrap',
        ...style,
      }}
      {...rest}
    >
      <div>
        <PageTitle>{title}</PageTitle>
        {subtitle && (
          <div style={{ margin: '6px 0 0', fontSize: 14, color: 'var(--text-secondary)' }}>
            {subtitle}
          </div>
        )}
      </div>
      {actions}
    </header>
  );
}
